module.exports = __webpack_public_path__ + "img/P17.71d4c4e4.png";